module.exports = __webpack_public_path__ + "img/usa.b6adb5ac.png";